export const title = {
  watch: {
    "$i18n.locale": function() {
      this.setTitle();
    }
  },
  methods: {
    getArgumentForTitle() {},
    setTitle() {
      let { chain, index } = this.getArgumentForTitle();
      chain = chain.filter(el => el);
      this.$store.dispatch("titleStore/setTitle", {
        chain,
        index
      });
    }
  },
  mounted() {
    this.setTitle();
  }
};
